import { render, staticRenderFns } from "./AboutLeisureCraft.vue?vue&type=template&id=73d74a9b"
import script from "./AboutLeisureCraft.vue?vue&type=script&lang=js"
export * from "./AboutLeisureCraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default})
